import { render, staticRenderFns } from "./reFundOrderDialog.vue?vue&type=template&id=47d86a23&"
import script from "./reFundOrderDialog.vue?vue&type=script&lang=js&"
export * from "./reFundOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports